import EventTeams from "app/components/EventTeams/EventTeams";
import { MarketTypes, SportsNameType } from "app/utils/const";
import { FormattedMessage } from "react-intl";
export const AsianEventNameSection = (
  props: Record<string, any>
): React.JSX.Element => {
  const { event, marketType, displayDraw } = props;
  const showCompetition = marketType === MarketTypes.OUTRIGHT;
  const shouldShowDraw =
    displayDraw && event.sportType !== SportsNameType.CRICKET;

  return (
    <div className="asian-event__team-names">
      {showCompetition ? (
        <div className="asian-event__competition-name">
          <span>{event.competition.name}</span>
        </div>
      ) : (
        <div className="asian-event__teams">
          <EventTeams
            teams={[
              {
                name: event.participant1,
              },
              {
                name: event.participant2,
              },
            ]}
          />
          {shouldShowDraw && (
            <div className="asian-event__runner-name">
              <span className="events-draw">
                <FormattedMessage tagName="span" id="events-draw" />
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
